<template>
  <div
    v-show="!isClosed"
    class="alert"
  >
    <div class="alert__head">
      <div
        class="alert__illust status-accent"
        :class="{
          'status-success': props.status === alertStatus.Success,
          'status-fail': props.status === alertStatus.Fail,
        }"
      >
        <i
          class="alert__icon"
          :style="{
            'background-image': `url(/auth/images/icon-${props.status}.png)`,
          }"
        ></i>
      </div>
      <h4 class="alert__title">{{ props.title }}</h4>
      <button
        class="alert__close-btn"
        type="button"
        @click="close"
      >Закрыть</button>
    </div>
    <div
      v-if="props.messages && props.messages.length"
      class="alert__body"
    >
      <p
        v-for="(message, index) of props.messages"
        :key="index"
      >
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeMount } from 'vue';
import { alertStatus } from '@/const';

const props = defineProps({
  id: Number,
  status: String,
  title: String,
  messages: { type: Array, default: () => [] },
});

const emit = defineEmits(['close']);
const isClosed = ref(false);

const close = () => {
  isClosed.value = true;
  emit('close', props.id);
};

let timerId = null;

onMounted(() => {
  timerId = setTimeout(() => {
    close();
  }, 10000);
});

onBeforeMount(() => {
  clearTimeout(timerId);
});
</script>

<style lang="scss" scoped>
@import '@/assets/scss/status-colors.scss';

.alert {
  box-sizing: border-box;
  padding: 16px;
  border-radius: 8px;
  background: $bg-second;
  font-family: 'Montserrat', Arial, Helvetica, sans-serif;
  border: 1px solid $color-delimiter-line;
  width: 100%;
}

.alert__head {
  display: flex;
  align-items: center;
}

.alert__title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  padding: 0px 10px 0px 0px;
}

.alert__illust {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  margin: 0px 8px 0px 0px;
}

.alert__icon {
  display: block;
  width: 24px;
  height: 24px;
  background-position: center;
  background-size: 20px;
  background-repeat: no-repeat;
}

.alert__close-btn {
  display: block;
  font-size: 0px;
  width: 24px;
  height: 24px;
  background: url('@/assets/images/icon-close-white.png') no-repeat center / contain;
  margin: 0px 0px 0px auto;
  opacity: 0.6;
  transition: opacity 300ms linear;
  align-self: flex-start;

  &:hover {
    opacity: 1;
  }
}

.alert__body {
  padding: 0px 0px 0px 42px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;

  p {
    margin: 0px;
  }

  p + p {
    margin: 10px 0px 0px;
  }
}
</style>
